import React from 'react'
import ModalComponent from '../../../../components/modal/index';
import PatientDetails from '../../scenes/registers/scenes/patient-details/index';
import { format } from 'date-fns';

class Portal extends React.Component {

}

class PaymentDetails extends React.Component {
    state = {
        dateString: ""
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.payment) {
            let date = new Date(nextProps.payment.date)
            var result = format(
                date,
                'DD/MM/YYYY'
            )

            return {dateString: result}
        }
        return null;
    }

    render() {
        if(!this.props.isActive || !this.props.payment)
            return null;

        return (
            <ModalComponent {...this.props} hasClose={true}>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">Detalles</p>
                    </header>
                    <section className="modal-card-body">
                        <p><b>Fecha: </b>{ this.state.dateString }</p> <br />
                        <p><b>Cantidad: </b>${this.props.payment.pay}</p> <br />
                        <p><b>Recibió: </b>{this.props.received ? this.props.received.userName : "N/A"}</p><br />
                        <p><b>Descripción: </b>
                            {this.props.payment.description ?
                            this.props.payment.description :
                            "Sin descripción"}
                        </p>
                    </section>
                </div>
            </ModalComponent>
        );
    }
}

export default function withPaymentModal(Component) {
    return class WithPaymentModal extends React.Component {
        state = {
            isActive: false,
            payment: null,
            received: null
        }

        openModal = (payment, received) => this.setState({isActive: true,payment: payment, received: received})
        closeModal = () => this.setState({isActive: false, payment: null})

        render() {
            return(
                <React.Fragment>
                    <Component {...this.props} openPaymentDetails={this.openModal} />
                    <PaymentDetails payment={this.state.payment}
                        received={this.state.received}
                        isActive={this.state.isActive}
                        close={this.closeModal}
                    />
                </React.Fragment>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/hocs/payment-details/index.js